import { render, staticRenderFns } from "./NewsBase.vue?vue&type=template&id=198732bd&scoped=true&"
import script from "./NewsBase.vue?vue&type=script&lang=js&"
export * from "./NewsBase.vue?vue&type=script&lang=js&"
import style0 from "./NewsBase.vue?vue&type=style&index=0&id=198732bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198732bd",
  null
  
)

export default component.exports